import { Cargo } from "view/cargos/types/cargo";
import { DataFormat } from "utils";
import { intl } from "LocaleWrapper";
import { useStoreState, Session } from "ezStore";
import { useMemo, useState } from "react";
import CustomerUpdateStatusChangerDialog from "view/customerUpdate/components/dialogs/CustomerUpdateStatusChangerDialog.tsx";
import { StatusChangeFragmentFragment as StatusChangeFragment, StatusFragmentFragment as StatusFragment } from "__generated__/view/statuses/graphql/fragments.generated";
import { dynamicTextColor } from "view/statuses/utils/StatusUtils";

type CustomerUpdateStatusChangerProps = {
	cargo: Cargo;
	selectedStatusChange?: StatusChangeFragment;
	onStatusChange: (statusChange: StatusChangeFragment) => void;
}

type CustomerUpdateStatusTagProps = {
	status?: StatusFragment;
	session: Session;
	onClick: () => void;
}

const CustomerUpdateStatusTag = ({ status, session, onClick }: CustomerUpdateStatusTagProps) => {
	const color = status?.color || "#ECECEC";
	const textColor = dynamicTextColor(color);

	const text = status ? DataFormat.status(status, session.locale) : intl.formatMessage({ id: "NO_STATUS_FOUND" });

	return (
		<div style={{ backgroundColor: color }} className="customer-update-status-tag">
			<div className="text" onClick={onClick}>
				<span style={{ color: textColor }}>
					{text}
				</span>
			</div>
		</div>
	);
};

const CustomerUpdateStatusChanger = ({ cargo, selectedStatusChange, onStatusChange }: CustomerUpdateStatusChangerProps) => {
	const session = useStoreState(state => state.session);

	const [ dialogOpen, setDialogOpen ] = useState(false);
	const [ localSelected, setLocalSelected ] = useState<StatusChangeFragment | undefined>(undefined);

	const displayed = localSelected ?? selectedStatusChange;

	const statusChanges = cargo.statusChanges ?? [];

	const dialogStatusChanges = useMemo(() => {
		if (!displayed) {
			return statusChanges;
		}

		const exists = statusChanges.some(s => s.id === displayed.id);
		return exists ? statusChanges : [ displayed, ...statusChanges ];
	}, [ statusChanges, displayed ]);

	return (
		<>
			<CustomerUpdateStatusTag status={displayed?.status} session={session} onClick={() => setDialogOpen(true)} />

			<CustomerUpdateStatusChangerDialog
				open={dialogOpen}
				onClose={() => setDialogOpen(false)}
				statusChanges={dialogStatusChanges}
				selectedStatusChange={displayed}
				onStatusChange={(statusChange) => {
					setLocalSelected(statusChange);
					onStatusChange(statusChange);
					setDialogOpen(false);
				}}
				session={session}
			/>
		</>
	);
};

export default CustomerUpdateStatusChanger;
